import React from "react" ;

/**
 * Specification of props for the line drawer
 */
export type CanvasThrobberLineProps = {
    /**
     * The x-coordinate to start the line at
     */
    x1: number;

    /**
     * The y-coordinate to start the line at
     */
    y1: number;

    /**
     * The x-coordinate to end the line at
     */
    x2: number;

    /**
     * The y-coordinate to end the line at
     */
    y2: number;

    /**
     * The width of the stroke, defined in vPX
     */
    w?: number;

    /**
     * A delay before the rendering of the rectangle begins, defined in percent
     * of the total drawing.
     */
    delay?: number;

    /**
     * The duration of the drawing of the rectangle, defined in percent of the
     * total drawing duration.
     */
    duration: number;

    /**
     * If you want multiple shapes to use the same easing-curve, then make sure
     * that they are given the same ease-name. This is useful if for instance
     * you are drawing two shapes that are part of the same visual entity.
     */
    ease?: string;
};

/**
 * This component is used to configure drawing of a line inside a
 * [[CanvasThrobber]].
 */
// tslint:disable-next-line variable-name
export const CanvasThrobberLine: React.FC<CanvasThrobberLineProps> = () => null;

/**
 * Type specification of the arc, so that we can safely identify it even if
 * react-hot-loader was used.
 */
export const typeOfCanvasThrobberLine = (<CanvasThrobberLine x1={0} y1={0} x2={0} y2={0} duration={0} />).type;
